/* unplugin-vue-components disabled */import script from "./message-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-image.vue?vue&type=script&lang=ts&setup=true"

import "./message-image.vue?vue&type=style&index=0&id=67a235a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a235a0"]])

export default __exports__